export const removeLeadingPlus = (phone: string): string => phone.replace(/^\+/, '');
